import { OrgProviderAction, OrgProviderState } from './types'

export function orgProviderReducer(state: OrgProviderState, action: OrgProviderAction): OrgProviderState {
    const next = { ...state }

    switch (action.type) {
        case 'loading:set': {
            next.loadingOrg = action.org ?? state.loadingOrg
            next.loadingDomains = action.domains ?? state.loadingDomains
            break
        }

        case 'org:set': {
            next.org = action.org
            if (action.domains) {
                next.domains = action.domains
            }
            break
        }

        case 'domains:set': {
            next.domains = action.domains
            break
        }
    }

    return next
}
